import {
  VacancyDetailGenInfoLoader,
  VacancyDetailMainInfoLoader,
  VacancyDetailTitleLoader,
} from '@/components/loader'
import Section from '@/layouts/section'

const LoaderSectionVacancyDetail = () => {
  return (
    <Section>
      <VacancyDetailTitleLoader />
      <VacancyDetailGenInfoLoader className="mb-16 md:mb-20" />
      <VacancyDetailMainInfoLoader className="bg-neutral-white rounded-sm" />
    </Section>
  )
}

export default LoaderSectionVacancyDetail
